import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DateTime } from 'luxon';
import { PieceRateService } from '../../services/piece-rate.service';
import { PieceRateAdjustment } from '@shared/models/piece-rate-adjustment';
import { PieceRateActivity } from '@shared/models/piece-rate-activity';
import {Subscription, combineLatest} from 'rxjs';
import {PieceRateActivityService} from "@shared/services/piece-rate-activity.service";


@Component({
    selector: 'app-piece-rate-form',
    templateUrl: './piece-rate-form.component.html',
    styleUrls: ['./piece-rate-form.component.scss']
})
export class PieceRateFormComponent implements OnInit, OnDestroy {

    items: MenuItem[];
    activeItem: MenuItem;
    activity: PieceRateActivity;
    visible = false;
    adjustmentCalculationActive = true;
    adjustmentObj: PieceRateAdjustment;
    showOpenDialog: boolean = false;
    shiftContext: { siteId: string, date: DateTime, shiftId: number, shiftNum: number };

    private subscriptions: Subscription[];

    constructor(private pieceRateService: PieceRateService,
                private pieceRateActivityService: PieceRateActivityService) { }

    ngOnInit(): void {
        this.activeItem = null;

        this.subscriptions = [
            this.pieceRateService.load().subscribe(result => {
                this.shiftContext = result.context;

                if (!result.adjustmentExists)
                    this.showOpenDialog = true;
            }),
            combineLatest([this.pieceRateActivityService.getActivitiesByBusinessUnit('SupplyChainServices'),
            this.pieceRateService.CurrentPieceRateAdjustment]).subscribe(([activities,adjustment]) => {
                this.adjustmentObj = adjustment;
                this.items = [];

                if (adjustment) {
                    const visibleForType = (type: PieceRateActivity): boolean =>
                        adjustment.activityConfigs.find(a => a.pieceRateActivity === type.id)?.showTab ?? false;

                    this.items = activities.map(a => ({
                        label: a.description,
                        command: () => this.activate(a),
                        visible: visibleForType(a)
                    }));

                    if (this.activeItem == null)
                        this.activeItem = this.items.find(i => i.visible);

                    if (this.activeItem)
                        this.activeItem.command();

                    this.visible = true;
                } else {
                    this.visible = false;
                }
            })
        ]
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
        this.pieceRateService.unload();
    }

    closeOpenDialog(): void {
        this.showOpenDialog = false;
    }

    initializeAdjustment(): void {
        this.showOpenDialog = false;
        this.pieceRateService.createPieceRateAdjustment();
    }

    activate(activity: PieceRateActivity): void {
        const tabLabel = activity.description;
        this.activity = activity;
        this.activeItem = this.items.find(i => i.label === tabLabel);

        this.pieceRateService.updateActiveSection(activity.id);
        this.adjustmentCalculationActive = [
            1,8,9,38 // BuilderRepairs, Deconstruction, and Reconstruction, PECO Repairs
        ].includes(activity.id);
    }
}
